import { render, staticRenderFns } from "./Landscape.vue?vue&type=template&id=5240a224&scoped=true"
import script from "./Landscape.vue?vue&type=script&lang=ts"
export * from "./Landscape.vue?vue&type=script&lang=ts"
import style0 from "./Landscape.vue?vue&type=style&index=0&id=5240a224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240a224",
  null
  
)

export default component.exports